import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

/** The languages the app actually ships strings for. */
export const SUPPORTED_LANGUAGES = ['en', 'ml'] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABEL: Record<AppLanguage, string> = {
  en: 'EN',
  ml: 'ML'
};

const STORAGE_KEY = 'quickbee_language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No hardcoded `lng`: it overrode the detector, so a saved choice never
    // survived a reload. The detector reads our own key first, then the
    // browser, and `fallbackLng` covers both coming back empty.
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    // `ml-IN` from a device locale must resolve to `ml`, not fall back to `en`.
    load: 'languageOnly',
    debug: false,
    resources: messages,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

/** Screen readers and font selection both key off `<html lang>`. */
function reflectOnDocument(lng: string): void {
  document.documentElement.lang = lng;
}

reflectOnDocument(i18n.resolvedLanguage ?? 'en');
i18n.on('languageChanged', reflectOnDocument);

export function setAppLanguage(lng: AppLanguage): void {
  void i18n.changeLanguage(lng);
}

export default i18n;
